import {
  FulfillmentMerchantCode,
  FulfillmentMerchantsResponse,
  FulfillmentPriorityResponse,
  FulfillmentPriorityUpdateShop,
} from "../@types/FulfillmentPriority";
import { wrapperRequests } from "./api";
import { routesURL } from "./routesUrl";

export async function getFulfillmentMerchants(): Promise<FulfillmentMerchantsResponse> {
  const { data } = await wrapperRequests<FulfillmentMerchantsResponse>(
    routesURL.settings.merchants,
    "GET",
  );

  return data;
}

export async function getFulfillmentPriorityShops(
  merchantCode: FulfillmentMerchantCode,
  options: { includeInactive: boolean },
): Promise<FulfillmentPriorityResponse> {
  const { data } = await wrapperRequests<FulfillmentPriorityResponse>(
    routesURL.settings.fulfillmentPriority,
    "GET",
    { params: { merchantCode, includeInactive: options.includeInactive } },
  );

  return data;
}

export async function updateFulfillmentPriorityShops(
  shops: FulfillmentPriorityUpdateShop[],
) {
  await wrapperRequests(routesURL.settings.fulfillmentPriority, "PATCH", {
    data: { shops },
  });
}
